import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector} from 'react-redux'
import { useHistory } from "react-router-dom";
import { getBranchList } from '../../actions/commonAction';
import { getUserPreference } from "../../utilities/common";
import { makeStyles } from '@material-ui/core/styles';
import { Button, TextField, Divider, Tooltip, Fab, Checkbox, FormControlLabel } from '@material-ui/core';
import moment from 'moment';
import { Table, TableHead, TableBody, TableCell, TableContainer, TableFooter, TablePagination, TableRow} from '@material-ui/core';
import TablePaginationActions from '../../components/Common/TablePagination';
import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import { Stepper, Step, StepLabel, StepConnector } from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import EnhancedTableHead from './EnhancedTableHead';
import Toolsbar from './Toolsbar';
import { getBasicInfo, getAllCargoStates, getBatchDataByTimePeriod, getNextOperations } from '../../actions/batchManagementActions';
import { showAlertSnackbar } from '../../reducers/uiSlice';
import AddTrajectoryComment from './AddTrajectoryComment';
import SelectedDrawer from './SelectedDrawer';
import { partnerList } from '../../constants/general';
import update from 'immutability-helper';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
        width: '100vw',
        backgroundColor: theme.palette.background.default,
        '& .MuiTableCell-root': {
            textAlign: 'center'
        }
    },
    paper: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    container: {
        // width: '100%',
        // padding: theme.spacing(2),    
        // textAlign: 'center',
        // color: theme.palette.text.secondary,        
    },  
    connectorLine: {
        // borderColor: 'red',
        // width: 10
      },
    alternativeLabel: {
        top: 10,
        left: "calc(-50% + 7px)",
        right: "calc(50% + 7px)"
    },      
    moreAction: {
        width: 350
    },
    shortCutMenu: {
        width: 350
    },    
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
      },    
    table: {
      minWidth: 750
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    searchFab: {
        color: green[500],
        width: 40, 
        height: 40, 
        // marginTop: 10,
        marginRight: 16,
    },
    iconButton: {
        marginTop: 30,        
        width: 30,         
        height: 30, 
        marginRight: 20,
    },
    editIcon: {
        color: green[500],
        fontSize: 20, 
    },
    toggle: {
        "&.Mui-selected": {
            backgroundColor: green[500]
        },  
        height: 20      
    },      
    tableCell: {
        borderStyle: 'solid', 
        borderWidth: 'thin', 
        borderColor: 'inherit', 
        borderTop: '0', 
        borderBottom: '0', 
        borderLeft: '0', 
        borderRight: '1',
    },
    stepLabel: {
        fontSize: '8px'
    }
  })); 

const MAX_BATCH_SELECTED = 6;
const MAX_BATCH_SEARCH_ALL = 6;
const MAX_BATCH_SEARCH = 10;

export default function BatchManagement(props) {
    const classes = useStyles();
    const {t, i18n} = useTranslation('batchManagement');
    const dispatch = useDispatch();
    const history = useHistory();

    const connector = <StepConnector classes={{
        // active: classes.connectorActive,
        // completed: classes.connectorCompleted,
        // disabled: classes.connectorDisabled,
        alternativeLabel: classes.alternativeLabel,
        line: classes.connectorLine
      }} />;

    let userPref = getUserPreference();

    /**
     * ******************************************************************************
     * ***********************TablePagination LOGIC**********************************
     * ******************************************************************************
     */
    const DEFAULT_START_PAGE = 0;
    const DEFAULT_ROWS_PER_PAGE = 20;
    const partnerIds = partnerList;
    const pageTotal = useSelector(state => state.batchManagement.pageTotal);

    const [page, setPage] = React.useState(DEFAULT_START_PAGE);
    const [rowsPerPage, setRowsPerPage] = React.useState(DEFAULT_ROWS_PER_PAGE);    
    //const emptyRows = rowsPerPage - Math.min(rowsPerPage, pageTotal - page * rowsPerPage);
    const emptyRows = 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));                
        setPage(0);
    };    

    useEffect(() => {
        if (page !== undefined && rowsPerPage !== undefined) {
            if(page === 0) {
                handleSearch(searchStartDate,searchEndDate,searchWarehouse,searchMawb,page,rowsPerPage);
            } else {
                let mawbs = validateMawb(searchMawb);
                if(mawbs !== false) {
                    handleSearch(searchStartDate,searchEndDate,searchWarehouse,mawbs,page,rowsPerPage);
                }
            }
        }
      }, [page,rowsPerPage]);
    

    /**
     * ******************************************************************************
     * ***************************PAGE DATA LOGIC************************************
     * ******************************************************************************
     */    
    const headCellList = useSelector(state => state.batchManagement.headCellList) || [];
    // const warehouseList = useSelector(state => state.batchManagement.warehouseList) || [];
    const allCargoStateList = useSelector(state => state.batchManagement.allCargoStateList) || [];
    const filterScanStatusList = useSelector(state => state.batchManagement.scanStatusList) || [];    
    const batchList = useSelector(state => state.batchManagement.batchList);
    const updateTrackingStatus = useSelector(state => state.batchManagement.updateTrackingStatus) ;
    
    const [isShowSelectedDrawer,setIsShowSelectedDrawer] = useState(false);

    const IS_SCANNING = '1';
    const IS_SCAN_COMPLETED = '2';
    const SUB_BATCH_TYPE = '2';
    const OPTION_ALL = '9';
    const OPTION_NO_WAREHOUSE_FACTOR = -1;
    const DEFAULT_ORDER = 'asc';
    const DEFAULT_ORDER_BY = 'dispatch_no';
    
    const [order, setOrder] = React.useState(DEFAULT_ORDER);
    const [orderBy, setOrderBy] = React.useState(DEFAULT_ORDER_BY);

    const [searchWarehouse,setSearchWarehouse] = useState(userPref.userCity);
    const [allWarehouseModel,setAllWarehouseModel] = useState(false);    //prohibit update action, browse only model
    const [isLimitExceeded, setIsLimitExceeded] = useState(false);
    const [searchWarehouseList,setSearchWarehouseList] = useState([]);
    const [searchStartDate,setSearchStartDate] = useState();
    const [searchEndDate,setSearchEndDate] = useState();
    const [searchMawb,setSearchMawb] = useState();    
    const [filterKeyWords,setFilterKeyWords] = useState();
    const [filterScanStatus,setFilterScanStatus] = useState();    
    const [filterCurrentStatus,setFilterCurrentStatus] = useState();
    const [filterCurrentStatusList,setFilterCurrentStatusList] = useState();
    const [filterScanDate,setFilterScanDate] = useState();
    const [filterScanDateList,setFilterScanDateList] = useState([]);
    const [filterSubBatch,setFilterSubBatch] = useState();
    const [filterSubBatchList,setFilterSubBatchList] = useState();
    const [filterCondition,setFilterCondition] = useState();
            
    const [headCellState, setHeadCellState] = useState([]);             //this struct record head cell
    const [rows,setRows] = useState([]);                                //the return results which fit the search or filter condiction

    const [pageTotalAllFuzzy, setPageTotalAllFuzzy] = useState(0);

    // Add comment for every trajectory
    const [openModalComment, setOpenModalComment] = useState(false);
    const [batchInfo, setBatchInfo] = useState([]);
      
    const [selectedDispatchNo,setSelectedDispatchNo] = useState([]);    //this struct record the select dispatch_no and master_air_way_bill
    const [branches, setBranches] = useState([]); // Use branches to replace warehouseList
    let prevDispatchNo = "";    //previous dispatchNo , if the current value is the same as the previous value then don't display the value
    let prevTrackInfo = [];     //previous tracking , display the trackinginfo when the new dispatch_no row start
    let curTrackInfo = [];      //current tracking , display the trackinginfo when the new dispatch_no row start
    let nChecked = 0;           //count the checked head columns , used for colSpan when display the transition status
    let nRowCount = 0;          //count rows have been outputted

    const [partnerFilter, setPartnerFilter] = useState(new Array(partnerIds.length).fill(true));

    const [selected, setSelected] = useState([]);

  /**
   * prevent the frequency response when the use input the drive id ,as the system will 
   * automatic send request to the backend to get the specific driver recorder
   */
   //const delayFilter = useCallback(_.debounce(value=>setFilterCondition(value), 350), []);

    // get branches
    useEffect(() => {
        setIsLimitExceeded(false);
        dispatch(getBranchList()).then((branches)=>{
            setBranches(branches);
        })
    }, [])

  //get the basic info such as warehouse list from the database
  useEffect(() => {
    if (branches.length > 0) {
        let [...arr] = branches;
        //arr.unshift({name: t('option_pls_select'), id: OPTION_PLS_SELECT});
        arr.unshift({name: t('option_all'), id: OPTION_NO_WAREHOUSE_FACTOR});
        setSearchWarehouseList(arr);
    } else {
        dispatch(getBasicInfo());
        dispatch(getAllCargoStates());
        init();    
    }
  },[branches]);

  // refresh the table if the head columns were changed
  useEffect(() => {      
    let headCells = [];
    headCells = JSON.parse(localStorage.getItem("head_cells") || '[]').filter((item)=>(item.checked)) ;
    if  (headCells.length === 0) {        
        headCells = headCellList.filter((item)=>(item.checked === 1));
    }        
    setHeadCellState(headCells);
  },[headCellList]);

  
  useEffect(() => {
    if(batchList) {
        if(allWarehouseModel && searchMawb) {
            if(batchList.length > 0) {
                handleFilterExec();
            }
        } else {
            if(batchList.data) {
                if (batchList.data.length > 0) {
                    handleFilterExec();
                } 
            }
        }
    }
  }, [filterCondition]); 

  /**
   * refresh if update tracking status successed
   */
  useEffect(() => {
    if (updateTrackingStatus === "SUCCESS") {
        let mawbs = validateMawb(searchMawb);
        if(mawbs !== false) {
            // 1. alter messages
            dispatch(showAlertSnackbar({type: "info", message: "Update tracking status successed!"}));
            
            // // 2.save the select options 
            // setIsNextStepExecuted(true);
            // setPreviousSelectedDispatchNo(selectedDispatchNo);
            let [...selectedOptions] = selectedDispatchNo;
            
            // 3.refresh the tracking status
            dispatch(getBatchDataByTimePeriod(searchStartDate,searchEndDate,searchWarehouse,mawbs,page,rowsPerPage,partnerFilter))
            .then(data => {
                if(allWarehouseModel && searchMawb) {
                    if (data !== undefined && data !== null) {
                        let dataConcat = [];
                        if(data.length > 0) {
                            data.map((res) => {
                                dataConcat = dataConcat.concat(res.data);
                            })
                        }
                        selectedOptions = modifySelectedOptions(selectedOptions, dataConcat);
                        selectedOptions = setSameStateForDispatchNo(selectedOptions);
                        setSelectedDispatchNo(selectedOptions)
                        setRows(dataConcat);
                        setPageTotalAllFuzzy(dataConcat.length)
                    }
                } else {
                    if (data.data !== undefined && data.data !== null && data.data.length > 0) {
                        selectedOptions = modifySelectedOptions(selectedOptions, data.data);
                        selectedOptions = setSameStateForDispatchNo(selectedOptions);
                        setSelectedDispatchNo(selectedOptions)
                        setRows(data.data); 
                    }
                }
            });
        }
    }
  }, [updateTrackingStatus]);  
  useEffect(() => {
    if(selectedDispatchNo?.length > 0) {
        let clone = [];
        selectedDispatchNo.forEach((dispatchNo) => {
            if(dispatchNo.mawb?.length > 0) {
                dispatchNo.mawb.forEach((batchNo) => {
                    if(batchNo.selected) {
                        clone.push(batchNo.master_air_waybill);
                    }
                })
            }
        })
        setSelected(clone);
    }
  }, [selectedDispatchNo])

  function modifySelectedOptions(selectedOptionsCurr, dataCurr) {
    for (let i = 0; i < selectedOptionsCurr.length ; i++) {
        for (let j = 0; j < selectedOptionsCurr[i].mawb.length; j++) {
            for (let k = 0; k < dataCurr.length ; k++) {
                if (selectedOptionsCurr[i].mawb[j].selected && (selectedOptionsCurr[i].mawb[j].master_air_waybill === dataCurr[k].master_air_waybill)) {
                    selectedOptionsCurr[i].mawb[j].tracking = dataCurr[k].tracking;
                }
            }    
        }
    }
    return selectedOptionsCurr;
  }

  return (
    <div className={classes.root} >
        <AddTrajectoryComment
            openModal={openModalComment}
            onClose={handleTrajectoryCommentClose}
            batchInfo={batchInfo}
        />
        <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
            <div>
                <div style={{display: 'flex', flexDirection: 'row', padding: 16, alignItems: 'center'}}>
                    <TextField
                        id="searchWarehouse"
                        select
                        SelectProps={{ native: true }}                 
                        label={t('label_warehouse')}
                        InputLabelProps={{ shrink: true }}                  
                        variant="outlined"
                        value={searchWarehouse}
                        onChange={(e) => {setSearchWarehouse(e.target.value);}}
                        style={{width: 200, paddingRight: 16}}  
                    >
                    {searchWarehouseList.map((item,index) => (
                        <option key={item + index} value={item.id}>
                        {item.name}
                        </option>
                    ))}                
                    </TextField>           
                    <TextField  
                        id="searchStartDate"
                        label={t('label_date_range_begin')}
                        type="date"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        value={moment.unix(searchStartDate).format("YYYY-MM-DD")}
                        onChange={(e)=>setSearchStartDate(moment(e.target.value + ' 00:00:00').unix())}
                        style={{width: 200, paddingRight: 16}}  
                    />        
                    <TextField 
                        id="searchEndDate"
                        label={t('label_date_range_end')}
                        type="date"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        value={moment.unix(searchEndDate).format("YYYY-MM-DD")}
                        onChange={(e)=>setSearchEndDate(moment(e.target.value + ' 23:59:59').unix())}
                        style={{width: 200, paddingRight: 16}}  
                    />
                    <TextField
                        multiline
                        id="searchMawb"
                        label={t('label_search_mawb')}
                        InputLabelProps={{ shrink: true }}                
                        variant="outlined"
                        value={searchMawb}
                        onChange={(e)=>setSearchMawb(e.target.value)}
                        style={{width: 200, paddingRight: 16}}   
                    />
                    <div style={{display: 'flex'}}>
                        {
                            partnerFilter &&
                            partnerIds &&
                            partnerIds.map((partner, index) => (
                                <FormControlLabel
                                    control={
                                        <Checkbox 
                                            color='secondary'
                                            checked={partnerFilter[index]}
                                            onChange={(e)=>{
                                                handlePartnerCheck(index);
                                            }}
                                        />
                                    }
                                    label={partner.name}
                                    style={{color: 'white'}}
                                />
                            ))
                        }
                    </div> 
                    <Button 
                        variant="contained" color="primary"
                        onClick={(e)=>handleSearchByButton(7)}
                        style={{width: 120, marginRight: 20, height: 40}} 
                    >
                        {t('button_recent_7days')}
                    </Button>
                    <Button 
                        variant="contained" color="primary"
                        onClick={(e)=>handleSearchByButton(30)}
                        style={{width: 120, marginRight: 20, height: 40}} 
                    >
                        {t('button_recent_30days')}
                    </Button>
                    <Button 
                        variant="contained" color="primary"
                        onClick={(e)=>handleSearchByButton(60)}
                        style={{width: 120, marginRight: 20, height: 40}} 
                    >
                        {t('button_recent_60days')}
                    </Button>
                    <span style={{paddingRight: 20}}>
                    </span>
                    <Tooltip title={t('tip_search')} aria-label='search' >
                        <Fab className={classes.searchFab}>
                            <SearchIcon onClick={handleSearchByRange}></SearchIcon>
                        </Fab>
                    </Tooltip>            
                    <Tooltip title={t('tip_reset')} aria-label="reset" >
                        <Fab className={classes.searchFab}>
                            <RefreshIcon onClick={handleRest}></RefreshIcon>
                        </Fab>
                    </Tooltip>

                    <CloseIcon onClick={handleClose} style={{marginLeft: 'auto', color: 'white'}}/>
                </div>
                <Divider />
                <div style={{display: 'flex', flexDirection: 'row', padding: 16}}>
                    <div >
                        <TextField 
                            id="filterScanStatus"
                            select
                            SelectProps={{native: true,}}  
                            label={t('label_scan_status')}
                            InputLabelProps={{ shrink: true }}                
                            variant="outlined"
                            value={filterScanStatus}
                            onChange={handleFilter}
                            style={{width: 200, paddingRight: 16}}     
                        >    
                        {filterScanStatusList.map((item,index) => (
                            <option key={item + index} value={item.value}>
                            {t(item.label)}
                            </option>
                        ))}             
                        </TextField>
                        <TextField 
                            id="filterCurrentStatus"
                            select
                            SelectProps={{native: true,}}  
                            label={t('label_current_status')}
                            InputLabelProps={{ shrink: true }}                
                            variant="outlined"
                            value={filterCurrentStatus}
                            onChange={handleFilter}
                            style={{width: 200, paddingRight: 16}}     
                        >
                            {   filterCurrentStatusList
                                ?
                                filterCurrentStatusList.map((item,index) => (
                                    <option key={item + index} value={item.to_code}>
                                        { i18n.language.includes("en") ? item.to_state: item.to_translation}
                                    </option>
                                ))    
                                :
                                null
                            }             
                        </TextField>
                        <TextField 
                            id="filterScanDate"
                            select
                            SelectProps={{native: true,}}                                   
                            label={t('label_scan_date')}
                            InputLabelProps={{ shrink: true }}  
                            type="date"
                            variant="outlined"
                            //value={moment.unix(filterScanDate).format("YYYY-MM-DD")}
                            value={filterScanDate}
                            onChange={handleFilter}     
                            style={{width: 200, paddingRight: 16}}     
                        >          
                        { filterScanDateList 
                            ?
                            filterScanDateList.map((item,index) => (
                                <option key={item + index} value={item.value}>
                                { (item.label === 'ALL')
                                ?
                                t('common:all')
                                :
                                item.label
                                }
                                </option>
                            ))
                            :
                            null
                        }    
                        </TextField>
                        <TextField 
                            id="filterSubBatch"
                            select
                            SelectProps={{native: true,}}  
                            label={t('label_sub_batch')}
                            InputLabelProps={{ shrink: true }}                
                            variant="outlined"
                            value={filterSubBatch}
                            onChange={handleFilter}
                            style={{width: 200, paddingRight: 16}}    
                        >   
                        {
                            filterSubBatchList 
                            ?
                            filterSubBatchList.map((item,index) => (
                                <option key={item + index} value={item.value}>
                                { (item.label === 'ALL')
                                ?
                                t('common:all')
                                :
                                item.label
                                }
                                </option>
                            ))
                            :
                            null
                        }    
                        </TextField> 
                    </div>
                    <Divider orientation="vertical" flexItem/>     
                    {/* Enable operation allWarehouseModel */}
                    <div style={{paddingLeft: 16}} >
                        <Toolsbar isDisabled={isLimitExceeded} headCellState={headCellState} rows={rows} warehouse={searchWarehouse} selectedDispatchNo={selectedDispatchNo} allWarehouseModel={allWarehouseModel}/>         
                    </div>
                    <Divider orientation="vertical" flexItem/>            
                    {/* <div style={{display: 'flex', flexDirection: 'row'}}> */}
                    <div style={{paddingLeft: 20, float: "right"}}>
                        <Button 
                            className={classes.button}
                            startIcon={<ExpandMoreIcon />}
                            variant="outlined" 
                            disabled={rows.length === 0}
                            onClick={e=>handleToggleDrawer(true,e)}
                        >
                            {t('button_selected_drawer')}
                        </Button>            
                        { isShowSelectedDrawer
                        ?
                        <SelectedDrawer selectedDispatchNo={selectedDispatchNo} toggleDrawer={toggleDrawer}/>
                        :
                        null
                        }      
                    </div>
                    <div style={{paddingLeft: 10, float: "right"}}>
                        <Button
                            color="primary"
                            onClick={handleCopySelected}
                            disabled={selected?.length <= 0}
                        >
                            {t('common:copy')}
                        </Button>
                    </div>                    
                </div>
                <Divider/>
            </div>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table"
                    className={classes.table}
                    aria-labelledby="tableTitle"
                    // aria-label="enhanced table"
                >
                    <EnhancedTableHead 
                        headCellState={headCellState} 
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                    />
                    <TableBody>
                    {stableSort(rows, getComparator(order, orderBy))
                        .map((row, index) => {
                        const isDispatchSelected = getSelectedDispatchNo(row);
                        const isMawbSelected = getSelectedMawb(row); 
                        return (
                            <React.Fragment>
                                <TableRow key={row.id}  tabIndex={-1} >
                                {             
                                    headCellState.map((item,idx)=>{
                                        if (item.checked) { 
                                            nChecked++;
                                            const value = row[item.id];                                                                                                                                                
                                            if (item.id === 'dispatch_no') {
                                                nRowCount++;    //counter increase                                        
                                                if (index === 0 || value !== prevDispatchNo) {
                                                    prevDispatchNo = value;
                                                    nRowCount = 1;  //renew the counter
                                                    prevTrackInfo = [];
                                                    [...prevTrackInfo] = row['tracking'];    
                                                    return (
                                                        <TableCell key={row.id + item.id} 
                                                            style={{borderStyle: 'solid', borderWidth: 'thin', borderColor: 'inherit', borderTop: '1', borderBottom: '0', borderLeft: '0', borderRight: '1'}}
                                                        > 
                                                            <ToggleButton key={row.id + item.id}
                                                                className={classes.toggle}
                                                                value={value} 
                                                                aria-label={value} 
                                                                selected={isDispatchSelected}
                                                                onClick={(e)=>handleDispatchNoClick(e,row)}   
                                                            >
                                                                {value}
                                                            </ToggleButton>    
                                                        </TableCell>       
                                                    )    
                                                } else {
                                                    return (                                        
                                                        <TableCell key={row.id + item.id} 
                                                            style={{borderStyle: 'solid', borderWidth: 'thin', borderColor: 'inherit', borderTop: '0', borderBottom: '0', borderLeft: '0', borderRight: '1',}}
                                                        > 
                                                        </TableCell>    
                                                    )    
                                                }
                                            } else if (item.id === 'master_air_waybill') {
                                                curTrackInfo = [];
                                                [...curTrackInfo] = row['tracking'];
                                                return (
                                                    <TableCell style={{textAlign: 'left'}}  key={row.id + item.id}> 
                                                        <ToggleButton 
                                                            className={classes.toggle}
                                                            value={value} 
                                                            aria-label={value}
                                                            selected={isMawbSelected}
                                                            onClick={()=>handleMawbClick(row)}
                                                        >
                                                            {value}
                                                        </ToggleButton> 
                                                    </TableCell>       
                                                )
                                            } else {
                                                return (                                        
                                                    <TableCell key={row.id + item.id} > 
                                                        { (item.format === 'date') 
                                                            ? 
                                                            moment.unix(value).format("YYYY-MM-DD hh:mm:ss") 
                                                            : (item.format === 'percent') ? (value * 100).toFixed(2) + "%": value
                                                        }
                                                    </TableCell>    
                                                )
                                            }
                                        }
                                    })
                                }
                                </TableRow>
                                {/** if the stat step is not the same for the same dispatch group then output each line for this group
                                 *   otherwise only output one state stpes for each group
                                 */
                                }
                                {                     
                                    ( selectedDispatchNo.filter((dispatchItem)=>dispatchItem.dispatch_no === row['dispatch_no']).length > 0 &&
                                        selectedDispatchNo.filter((dispatchItem)=>dispatchItem.dispatch_no === row['dispatch_no'])[0].sameState === false) 
                                    ?
                                    <TableRow>
                                        <TableCell
                                            style={{borderStyle: 'solid', borderWidth: 'thin', borderColor: 'inherit', borderTop: '0', borderBottom: '0', borderLeft: '0', borderRight: '1',}}
                                        > 
                                        </TableCell>    
                                        <TableCell style={{textAlign: 'left'}} colSpan={nChecked - 1} >
                                            <div style={{width: '30%'}}>
                                            <Stepper activeStep={prevTrackInfo.length} connector={connector}>
                                            {
                                                curTrackInfo.map((trackingItem,trackingIndex)=>{
                                                    let str = (trackingItem.transition_time === 0 ? t('format_immedately') : Math.round(trackingItem.transition_time / (60*60),2) + "h");
                                                    return(
                                                        <Step 
                                                            key={trackingItem.id}
                                                            onClick={() => handleTrajectoryAddEditComment(trackingItem)}
                                                            style={{
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            <StepLabel className={classes.stepLabel}>
                                                                {trackingItem.state + "(" + str +")"}  <br/>
                                                                {moment.unix(trackingItem.update_time).format("YYYY-MM-DD hh:mm:ss")}
                                                            </StepLabel>
                                                        </Step>               
                                                    )
                                                })
                                            }
                                            </Stepper>
                                            </div>
                                        </TableCell> 
                                    </TableRow>
                                    :
                                    null
                                }  
                                {                     
                                    (   (selectedDispatchNo.filter((dispatchItem)=>dispatchItem.dispatch_no === row['dispatch_no']).length > 0) &&
                                        (selectedDispatchNo.filter((dispatchItem)=>dispatchItem.dispatch_no === row['dispatch_no'])[0].sameState) && 
                                        (nRowCount === selectedDispatchNo.filter((dispatchItem)=>dispatchItem.dispatch_no === row['dispatch_no'])[0].mawb.length)
                                    )                             
                                    ?
                                    <TableRow>
                                        <TableCell
                                            style={{borderStyle: 'solid', borderWidth: 'thin', borderColor: 'inherit', borderTop: '0', borderBottom: '0', borderLeft: '0', borderRight: '1',}}
                                        > 
                                        </TableCell>    
                                        <TableCell style={{textAlign: 'left'}} colSpan={nChecked - 1} >
                                            <div style={{width: '30%'}}>
                                            {/* <Stepper activeStep={prevTrackInfo.length} alternativeLabel={true}> */}
                                            <Stepper activeStep={prevTrackInfo.length} connector={connector}>
                                            {
                                                prevTrackInfo.map((trackingItem,trackingIndex)=>{
                                                    let str = (trackingItem.transition_time === 0 ? t('format_immedately') : Math.round(trackingItem.transition_time / (60*60),2) + "h");
                                                    return(
                                                        <Step 
                                                            key={trackingItem.id}
                                                            onClick={() => handleTrajectoryAddEditComment(trackingItem)}
                                                            style={{
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            <StepLabel className={classes.stepLabel}>
                                                                {trackingItem.state + "(" + str +")"}  <br/>
                                                                {moment.unix(trackingItem.update_time).format("YYYY-MM-DD hh:mm:ss")}
                                                            </StepLabel>
                                                        </Step>               
                                                    )
                                                })
                                            }
                                            </Stepper>
                                            </div>
                                        </TableCell> 
                                    </TableRow>
                                    :
                                    null
                                }                                  
                            </React.Fragment>
                        );
                        })}
                        {emptyRows > 0 && (
                        <TableRow style={{ height: 20 * emptyRows }}>
                            <TableCell colSpan={6} />
                        </TableRow>
                        )}                        
                    </TableBody>
                </Table>
                <TablePagination 
                    rowsPerPageOptions={[10, 20, 200, { label: 'All', value: pageTotal}]}
                    colSpan={3}
                    count={pageTotal || pageTotalAllFuzzy}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                    }}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    //ActionsComponent={(subProps)=> <TablePaginationActions ref={paginationRef} {...subProps}/>}
                    ActionsComponent={TablePaginationActions}                
                />                     
            </TableContainer>
        </div>
    </div>
  );

    function handleCopySelected() {
        navigator.clipboard.writeText(selected.toString())
        dispatch(showAlertSnackbar({message: t('common:copied'), type: 'info'}))
    }

    function handlePartnerCheck(index) {
        let copy = {...partnerFilter};
        setPartnerFilter(update(partnerFilter, {[index]: {$set: !copy[index]}}));
    }

    function validateMawb(mawbInput) {
        const mawbTrim = mawbInput.replace(/\s+/g, '');
        let mawbArr = mawbTrim.split(',');
        let mawbCurr = '';
        let count = 0;
        if(mawbArr.length > 0) {
            mawbArr.map((mawb) => {
                if(mawb) {
                    count++;
                    if(count > MAX_BATCH_SEARCH_ALL) {
                        if(allWarehouseModel) {
                            dispatch(showAlertSnackbar({type: "error", message: "Exceed max search number (6)"}));
                            return false;
                        } else if(count > MAX_BATCH_SEARCH) {
                            dispatch(showAlertSnackbar({type: "error", message: "Exceed max search number (10)"}));
                            return false;
                        }
                    }
                    mawbCurr += ',' + mawb;
                }
            })
            if(mawbCurr) {
                mawbCurr = mawbCurr.substring(1);
            }
        }
        return mawbCurr;
    }

    /**
     * add or edit comment to batch(es)
     */
    function handleTrajectoryAddEditComment(item) {
        // in all warehouse browse model all action is prohibited  
        // Enable
        // if (allWarehouseModel) return;

        setBatchInfo(item);
        setOpenModalComment(true);
    }
    function handleTrajectoryCommentClose() {
        setOpenModalComment(false);
    }

  function handleRequestSort (event, property) {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  /**
   * 
   */
  function init() {
    setSearchStartDate(moment((new Date()).getTime()).unix());
    setSearchEndDate(moment((new Date()).getTime()).unix());
    setSearchWarehouse(userPref.userCity);
    setSearchMawb('');
    setFilterCurrentStatusList([]);
    setFilterScanDateList([])
    
    setRows([]);
  }

  /**
   * init the data that can be use by the filter
   * @param {*} batchList 
   */
  function assemabelFilter(batchList) {
    let array = [];
    let scanDateArray = [];
    let subBatchArray = [];
    let statusList = [];
    let batchListCurr = [];
    batchListCurr = batchList;
    batchListCurr.forEach(element => {
        array.push({label: moment.unix(element['scan_start_date']).format("YYYY-MM-DD hh:mm:ss"), value: element['scan_start_date']});

        if (element['batch_type']+'' === SUB_BATCH_TYPE) {
            subBatchArray.push({label: element['master_air_waybill'], value: element['master_air_waybill']});
        }        
    });

    //init the scan data list
    if (array.length > 0) 
        array.unshift({label: 'ALL', value: OPTION_ALL});

    array.map((item,index)=>{
        let nCount = 0;
        for ( let i = 0; i < scanDateArray.length ; i++) {
            if (scanDateArray[i].value === item.value) {
                nCount++;
                break;                
            }
        }
        if (nCount === 0) {
            scanDateArray.push(item);
        }
    });    
    setFilterScanDateList(scanDateArray);

    //init the sub batch list
    if (subBatchArray.length > 0) 
        subBatchArray.unshift({label: 'ALL', value: OPTION_ALL});
    setFilterSubBatchList(subBatchArray);

    //init the status list
    [...statusList] = allCargoStateList;
    if (statusList.length > 0)
        statusList.unshift({"to_state": "ALL","to_translation": "全部","to_code": OPTION_ALL});
    setFilterCurrentStatusList(statusList);    

  }

  /**
   * init the data struct of the selected dispatchNo and select master_air_way_bill
   * the status will be changed based on the user click actiom
   * selectedOptions {
   *   dispatch_no: batchList[i].dispatch_no,
   *   selected: false,     -- default false, changing by the use select action (equals && select result of the master_air_way_bill )
   *   mawb: {
   *            master_air_waybill  
   *            tracking
   *            total_items
   *            selected     -- default false,changing by the use select action
   *         }
   *   sameState: true,      -- default true
   * }
   * @param {} batchList 
   */
  function assemabelSelectedItem(batchList) {

    let selectedOptions = [];
    let nExist = 0;
    let obj = {};
    let batchListCurr = [];
    batchListCurr = batchList;

    // assemble the data struct which grouped by dispatch_no
    // and set the default value
    for (let i = 0; i < batchListCurr.length ; i++) {
        nExist = 0;
        obj = {
            master_air_waybill: batchListCurr[i].master_air_waybill,
            tracking: batchListCurr[i].tracking,
            total_items: batchListCurr[i].total_items,
            selected: false,
        };
            
        for (let j = 0; j < selectedOptions.length; j++) {
            if (selectedOptions[j].dispatch_no === batchListCurr[i].dispatch_no) {
                nExist++ ;
                selectedOptions[j].mawb.push(obj);
                break;
            }            
        }

        if (nExist === 0) {
            selectedOptions.push({
                dispatch_no: batchListCurr[i].dispatch_no,
                selected: false,
                mawb: [obj],
                sameState: true,
            });
        }
    }
    selectedOptions = setSameStateForDispatchNo(selectedOptions);    
    return setSelectedDispatchNo(selectedOptions);
  }
  
    // set the sameStae flag of each dispatch_no
    // when the state steps of the all master_air_way_bill which belong to one dispatch_no then display one state steps,
    // otherwise display status step for each master_air_way_bill  
  function setSameStateForDispatchNo(selectedOptions) {
    for (let i = 0; i < selectedOptions.length; i++) {
        //get the stat steps of the first mastr_air_way_bill
        let prevStatSteps = "";
        for (let k = 0; k < selectedOptions[i].mawb[0].tracking.length;k++) {
            prevStatSteps += selectedOptions[i].mawb[0].tracking[k].state;
        }

        //get the stat steps of the following mastr_air_way_bill
        for (let j = 1; j < selectedOptions[i].mawb.length; j++) {
            let curStatSteps = "";
            for (let k = 0; k < selectedOptions[i].mawb[j].tracking.length;k++) {
                curStatSteps += selectedOptions[i].mawb[j].tracking[k].state;
            }
            // the stat steps of the master_air_way_bill which belong to same dispatch_no is not the same
            // record the different status
            if (prevStatSteps !== curStatSteps) {   
                selectedOptions[i].sameState = false;
                break;
            }
        }
    }      

    return selectedOptions;
  }

    function handleClose() {
        history.goBack();
    }

    function checkPartnerSetExist() {
        let partnerSet = false;
        partnerFilter.map((partner) => {
            if(partner) {
                partnerSet = partner;
                return;
            }
        })
        if(partnerSet) {
            return true;
        } else {
            dispatch(showAlertSnackbar({message: t('must_select_partner'), type: 'error'}))
            return false;
        }
    }

  /**
   * 
   * @param {*} days 
   */
  function handleSearchByButton(days) {
      if(!checkPartnerSetExist()) {
        return;
      }
      let mawbs = validateMawb(searchMawb);
    if(mawbs !== false) {
        let searchStartDate = new Date(new Date(new Date().setDate(new Date().getDate() - days + 1)).toLocaleDateString());
        let searchEndDate = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1);

        setSearchStartDate(moment(searchStartDate).unix());
        setSearchEndDate(moment(searchEndDate).unix());

        setPage(0);
        handleSearch(moment(searchStartDate).unix(),moment(searchEndDate).unix(),searchWarehouse,mawbs,0,rowsPerPage);
    }
  } 

  function handleSearchByRange() {
    if(!checkPartnerSetExist()) {
        return;
      }
      let mawbs = validateMawb(searchMawb);
    if(mawbs !== false) {
        setPage(0);
        handleSearch(searchStartDate,searchEndDate,searchWarehouse,mawbs,0,rowsPerPage);   
    }
  }  

  function transferPartnerArrToStr() {
    let str = '';
    partnerFilter.map((partner, index) => {
        if(partner) {
            str += ',' + partnerIds[index].id;
        }
    })
    return str.substring(1);
  }

  /**
   * search the data by the condiction (startdate,enddate,warehouse,page,rowsPerPage)
   * 
   * @param {*} fromTS 
   * @param {*} toTS 
   * @param {*} warehouse 
   * @param {*} mawb 
   * @param {*} startPage 
   * @param {*} pageSize 
   * @returns 
   */
  function handleSearch(fromTS,toTS,warehouse,mawb='',startPage=0,pageSize=DEFAULT_ROWS_PER_PAGE) {
    // noundary check
    if (fromTS === undefined || toTS === undefined || 
        warehouse === undefined || warehouse === null || warehouse === '') 
        return;
    
    let allWarehouseHere = false;
    if (parseInt(warehouse) === OPTION_NO_WAREHOUSE_FACTOR) {
        setAllWarehouseModel(true);
        allWarehouseHere = true;
    } else {
        setAllWarehouseModel(false);
        allWarehouseHere = false;
    }            

    const partnerFilterStr = transferPartnerArrToStr();

    dispatch(getBatchDataByTimePeriod(fromTS,toTS,warehouse,mawb,startPage + 1,pageSize,partnerFilterStr)) 
    .then((data)=>{
        if(allWarehouseHere && searchMawb) {
            let dataConcat = [];
            if(data.length > 0) {
                data.map((res) => {
                    dataConcat = dataConcat.concat(res.data);
                })
            }
            assemabelFilter(dataConcat);   
            assemabelSelectedItem(dataConcat);
            setRows(dataConcat);
            setPageTotalAllFuzzy(dataConcat.length)
        } else {
            if(data.data !== undefined && data.data !== null) {
                assemabelFilter(data.data);   
                assemabelSelectedItem(data.data);
                setRows(data.data);
            }
        }            
    });
  }

  /**
   * filter the batch data according to the filter condition
   */
  function handleFilter(event) {
    // if (event.target.id === "filterKeyWords") {
    //     setFilterKeyWords(event.target.value);
    //     delayFilter({
    //         keyWords: event.target.value, 
    //         scanstatus: filterScanStatus, 
    //         currentStatus: filterCurrentStatus,
    //         scandate: filterScanDate,
    //         subBatch: filterSubBatch
    //       });  
    // } else 
    if (event.target.id === "filterScanStatus") {
        setFilterScanStatus(event.target.value);
        setFilterCondition({
            keyWords: filterKeyWords, 
            scanstatus: event.target.value, 
            currentStatus: filterCurrentStatus,
            scanDate: filterScanDate,
            subBatch: filterSubBatch
        });
    } else if (event.target.id === "filterCurrentStatus") {
        console.log(event.target.value)
        setFilterScanStatus(event.target.value);
        setFilterCondition({
            keyWords: filterKeyWords, 
            scanstatus: filterScanStatus, 
            currentStatus: event.target.value,
            scanDate: filterScanDate,
            subBatch: filterSubBatch
        });
    } else if (event.target.id === "filterScanDate") {
        setFilterScanStatus(event.target.value);
        setFilterCondition({
            keyWords: filterKeyWords, 
            scanstatus: filterScanStatus, 
            currentStatus: filterCurrentStatus,
            scanDate: event.target.value,
            subBatch: filterSubBatch
        });
    } else if (event.target.id === "filterSubBatch") {
        setFilterScanStatus(event.target.value);
        setFilterCondition({
            keyWords: filterKeyWords, 
            scanstatus: filterScanStatus, 
            currentStatus: filterCurrentStatus,
            scanDate: filterScanDate,
            subBatch: event.target.value
        });
    }
  }

  /**
   * 
   */
  function handleFilterExec() {
    if (!filterCondition) return;

    const batchListCurr = [];

    if(allWarehouseModel && searchMawb) {
        let dataConcat = [];
        if(batchList.length > 0) {
            batchList.map((res) => {
                dataConcat = dataConcat.concat(res.data);
            })
        }
        batchListCurr = dataConcat;
    } else {
        batchListCurr = batchList;
    }

    let [...list] = batchListCurr;
    
    // if (filterCondition.keyWords) {
    //     list = list.filter((item,index)=>(item.master_air_waybill.indexOf(filterCondition.keyWords) !== -1)            
    //     );
    // }
    
    if (filterCondition.scanstatus && filterCondition.scanstatus === IS_SCANNING) {
        list = list.filter((item,index)=>(item.is_scanning === 1));
    } else if (filterCondition.scanstatus && filterCondition.scanstatus === IS_SCAN_COMPLETED) {
        list = list.filter((item,index)=>(item.is_scan_completed === 1));
    }
    
    if (filterCondition.currentStatus && filterCondition.currentStatus !== OPTION_ALL) {
        list = list.filter((item,index)=>(item.status + '' === filterCondition.currentStatus + ''));
    }

    if (filterCondition.scanDate && filterCondition.scanDate !== OPTION_ALL) {
        list = list.filter((item,index)=>((item.scan_start_date + "") === filterCondition.scanDate));
    }

    if (filterCondition.subBatch) {
        if (filterCondition.subBatch === OPTION_ALL) {
            list = list.filter((item,index)=>(item.batch_type+"" === SUB_BATCH_TYPE));
        } else {
            list = list.filter((item,index)=>(item.master_air_waybill === filterCondition.subBatch));
        }    
    }    

    setRows(list);
  }


  /**
   * 
   */
  function handleRest() {
    init();    
  }


  /**
   * set the "select" property 1/-1 according to the click action
   * when the new value is 1 : select all the mawb item belong the clicked dispath_no
   * when the new value is -1 : unselect all the mawb item belong the clicked dispath_no
   * @param {*} row 
   */
  function handleDispatchNoClick(event,row) {
    // in all warehouse browse model all action is prohibited  
    // disable select in pack
    if (allWarehouseModel) return;


    let [...selectedOptions] = selectedDispatchNo;

    for (let i = 0; i< selectedDispatchNo.length; i++) {
        if (selectedDispatchNo[i].dispatch_no === row.dispatch_no) {
            for (let j=0; j < selectedDispatchNo[i].mawb.length; j++) {
                selectedDispatchNo[i].mawb[j].selected = !selectedDispatchNo[i].selected;
            }
            selectedDispatchNo[i].selected = !selectedDispatchNo[i].selected;
        }
    }

    setSelectedDispatchNo(selectedOptions);    
  }

  /**
   * 1.scan the sub array "mawb" and set the "selected" property according to the click action
   * 2.set selected property of dispath_no to 1 if all the selected property of mawb arry is 1
   *   set selected property of dispath_no to -1 if all the selected property of mawb arry is -1
   * @param {*} row 
   */
  function handleMawbClick(row) {
    // in all warehouse browse model all action is prohibited  
    // enable at most 6 click
    // if (allWarehouseModel) return;

    let nIndex = -1;
    let [...selectedOptions] = selectedDispatchNo;

    //.scan the selectedDispatchNo array set the "selected" property
    //.record the index of the selectedDispatchNo array which match the clicked master_air_waybill
    for (let i=0; i < selectedOptions.length; i++) {        
        for (let j=0; j < selectedOptions[i].mawb.length; j++) {
            if (selectedOptions[i].mawb[j].master_air_waybill === row.master_air_waybill) {
                selectedOptions[i].mawb[j].selected = !selectedOptions[i].mawb[j].selected;
                nIndex = i;
                break;
            }    
        }
        if (nIndex !== -1) 
            break;
    }

    //scan the selected status of mawb arry 
    //.set selected property of dispath_no to 1 if all the selected property of mawb arry is 1
    //.set selected property of dispath_no to -1 if all the selected property of mawb arry is -1
    if (nIndex === -1) return;
    let nSelected = 0;
    //let nTotal = 0;
    for (let j = 0 ; j < selectedOptions[nIndex].mawb.length; j++) {
        if (selectedOptions[nIndex].mawb[j].selected) {
            nSelected++;
            //nTotal = selectedDispatchNo[nIndex].mawb[j].total_items;

            // Show alert and disable to add when number exceed 6
            if(allWarehouseModel) {
               if(nSelected > MAX_BATCH_SELECTED) {
                    setIsLimitExceeded(true);
                    dispatch(showAlertSnackbar({message: t('exceed_six'), type: 'error'}))
                } else {
                    setIsLimitExceeded(false);
                }
            } else {
                setIsLimitExceeded(false);
            }
        }
    }

    if (nSelected === 0) {
        selectedOptions[nIndex].selected = false;
        //selectedDispatchNo[nIndex].total_items = 0;
    } else {
        selectedOptions[nIndex].selected = true;
        //selectedDispatchNo[nIndex].total_items = nTotal;
    }

    setSelectedDispatchNo(selectedOptions);
  }
    
  /**
   * return the selected status of current dispatchNo
   * @param {*} row 
   */
  function getSelectedDispatchNo(row) {              
    for (let i=0; i < selectedDispatchNo.length; i++) {
        if (selectedDispatchNo[i].dispatch_no === row['dispatch_no']) {
            return selectedDispatchNo[i].selected;
        }
    }    
    return false;
  }
  
  /**
   * return the selected status of current master_air_waybill
   * @param {*} row 
   * @returns 
   */
  function getSelectedMawb(row) {    
    for (let i=0; i< selectedDispatchNo.length; i++) {        
        for (let j=0; j < selectedDispatchNo[i].mawb.length; j++) {
            if (selectedDispatchNo[i].mawb[j].master_air_waybill === row.master_air_waybill) {
                return selectedDispatchNo[i].mawb[j].selected;
            }    
        }
    }
    return false;
  }

  /**
   * read the search SN from local storage
   * open the SearchSN history List, max length is 8
   */
   function handleToggleDrawer(open,event) {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }

    if (isShowSelectedDrawer !== open) {
        setIsShowSelectedDrawer(open);
    }

  } 

  /**
   * control the SearchSN history List, max length is 8
   */
  function toggleDrawer(open,event) {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }

    if (isShowSelectedDrawer !== open) {
        setIsShowSelectedDrawer(open)
    }
  } 
} 